import * as React from 'react';

import { getDisplayName } from 'components/hoc';
import routesConfig from 'defs/routes';
import { HistoryType } from 'types/withRouter';

type WithBackToDashboardReceivePropsType = {
	history: HistoryType;
};

export type WithBackToDashboardPropsType = {
	onBackFromDetail: () => void;
};

/*
 * Enable history back for card details in favorites view
 * @see FavoritesDetailView
 * @requires withRouter
 * @param {React.Component} WrappedComponent
 */
export default function withBackToDashboard<P extends object>(WrappedComponent: React.ComponentType<P>) {
	return class HistoryBackProxy extends React.Component<P & WithBackToDashboardReceivePropsType> {
		public static displayName = `withBackToDashboard(${getDisplayName(WrappedComponent)})`;

		/**
		 * fix browser back for ios
		 * @see PULSWM-2783
		 * save scroll position
		 * @see PULSWM-3117
		 */
		public handleClickBack = () => {
			setTimeout(() => {
				this.props.history.push(routesConfig.dashboard.indexRoute.href);
			}, 1);
		};

		public render() {
			return <WrappedComponent onBackFromDetail={this.handleClickBack} {...this.props} />;
		}
	};
}
